<template>
    <button
         :style="{
            backgroundImage: 'url(images/commons/btnSearch.png)'
         }"
         class="relative w-10 h-10 mr-2 md:w-10 md:h-10 2xl:w-16 2xl:h-16 bg-center bg-no-repeat bg-contain pointer-events-auto  shadow-2xl rounded-full"
         @click="$eventbus.$emit('search:modal:show')"
    ></button>
</template>

<script>
export default {
    name: "BtnSearch",
    mounted(){
        tippy(this.$el, {
            theme: 'light',
            content: 'Rechercher',
        });
    }
}
</script>

<style scoped>

</style>
